import { callAjax } from '../../../assets/js/helpers'
import debounce from 'lodash/debounce'
import PaginationAjax from '../../Pagination/PaginationAjax'

class FiltersQuery {
  form: HTMLFormElement
  loader: HTMLElement
  postsContainer: HTMLElement
  paginationContainer: HTMLElement | undefined

  constructor(form: HTMLFormElement) {
    this.form = form
    this.postsContainer = document.getElementById('filtered-posts') as HTMLElement
    this.loader = document.querySelector('.filtered-posts-container__loader') as HTMLElement
  }

  public async getPosts(additionalQuery?: { [key: string]: string }) {
    if (!this.postsContainer) return

    const formData = new FormData(this.form)

    formData.append('action', 'FilterPostsAjax')

    if (additionalQuery) {
      for (const [key, value] of Object.entries(additionalQuery)) {
        formData.append(key, value)
      }
    }

    this.form.classList.add('is-loaded')
    this.postsContainer.innerHTML = ''

    return callAjax({
      method: 'POST',
      body: formData,
    })
      .then(res => res.json())
      .then(res => {
        this.postsContainer.innerHTML = res.html
        this.paginationContainer = document.querySelector('.filtered-posts__pagination') as HTMLElement
        this.paginationContainer.innerHTML = res.pagination
        new PaginationAjax(this.paginationContainer).handleClick(e => this.getPosts({ paged: `${e.pageNumber}` }))

        const paginationItems = document.querySelectorAll('.pagination__item')
        const paginationItemsBtn = document.querySelectorAll('.job-offers__pagination .page-numbers')

        if (paginationItems) {
          paginationItems.forEach(item => {
            item.addEventListener('click', () => {
              window.scrollTo(0, 0)
            })
          })
        }

        if (paginationItemsBtn) {
          paginationItemsBtn.forEach(item => {
            item.addEventListener('click', () => {
              window.scrollTo(0, 0)
            })
          })
        }

        this.form.classList.remove('is-loaded')
      })
      .then(() => {
        const inputs = document.querySelectorAll('input[name="is_in_pdf"]') as NodeListOf<HTMLInputElement>
        const inputAll = document.querySelector('input[name="select-pdf-all"]') as HTMLInputElement

        if (inputs && inputs.length) {
          inputs.forEach(input => {
            const postId = input.getAttribute('data-post-id')

            input.addEventListener('change', () => {
              const inputId = input.getAttribute('data-post-id') as string

              if (input.checked != true) {
                const inputAllPosts = inputAll.getAttribute('posts') as string
                const idsArray = inputAllPosts.split(',') as Array<string>
                const newIdsArray = idsArray.filter(x => x != inputId)
                const newPosts = newIdsArray.join(',')
                inputAll.setAttribute('posts', newPosts)
              } else {
                const inputAllPosts = inputAll.getAttribute('posts') as string
                const idsArray = inputAllPosts.split(',') as Array<string>

                if (idsArray.indexOf(inputId) < 0) {
                  idsArray.push(inputId)
                }

                const newPosts = idsArray.join(',')
                inputAll.setAttribute('posts', newPosts)
              }
            })

            if (postId) {
              if (inputAll.checked) {
                const inputAllPosts = inputAll.getAttribute('posts') as string
                const idsArray = inputAllPosts.split(',') as Array<string>
                if (idsArray.indexOf(postId) > -1) {
                  input.checked = true
                }
              }
              if (!inputAll.checked) {
                input.checked = false
              }
            }
          })
        }
      })
  }

  public onInputChange(cb: () => Promise<void>) {
    const inputs = this.form.querySelectorAll('input.query-filter')

    inputs.forEach(input => {
      input.addEventListener(
        'change',
        debounce(() => {
          cb()
          this.setUrl()
        }, 300),
      )
    })

    return this
  }

  /**
   * Append params to url
   * @returns
   */
  private setUrl() {
    const formData = new FormData(this.form)

    // @ts-ignore
    const urlParams = new URLSearchParams(formData).toString()
    const new_url = '?' + urlParams
    window.history.pushState('data', document.title, new_url)

    return this
  }
}

export default FiltersQuery
